export default __webpack_public_path__ + "static/media/exportWay.31339c4d.jpg";